// Профиль участника кабинета app.weern.com (ADR-0063 rev2).
//
// Участник — сущность ПЛАТФОРМЫ (`platform_users`), доступ в work/eyeq — это
// membership. Поэтому эндпоинт живёт на платформенном воркере, а не в work.
//
// Кабинет при каждом заходе рассказывает о себе минимум, который нельзя
// узнать с сервера: запущен ли он как установленное приложение, с какого
// класса устройства и на каком языке. Плюс метки ссылки, по которой человек
// пришёл (целевая задача и канал привлечения) — их владелец потом правит
// руками в таблице участников, поэтому клиент их только ПРЕДЛАГАЕТ: уже
// проставленное значение сервер не перетирает.
//
// Ничего похожего на PII здесь нет: ни UA целиком, ни модели устройства —
// только класс (ios | android | desktop | other).
import { z } from 'zod';

export const APP_TARGET_TASKS = ['gift', 'screenshot', 'coupon', 'membership', 'receipt'] as const;
export type AppTargetTask = (typeof APP_TARGET_TASKS)[number];

export const AppHelloReqSchema = z.object({
  /** Запущено как установленное приложение (display-mode: standalone). */
  standalone: z.boolean().default(false),
  /** Класс устройства — из UA, без модели и версии. */
  device: z.enum(['ios', 'android', 'desktop', 'other']).default('other'),
  /** Язык интерфейса кабинета (BCP-47-ish, как в shell i18n). */
  locale: z.string().trim().max(16).default(''),
  /** Метка оффера из ссылки (?task=) — только если пришла в этом заходе. */
  task: z.enum(APP_TARGET_TASKS).optional(),
  /** Канал привлечения из ссылки (?ch=). */
  channel: z.string().trim().max(32).optional(),
});
export type AppHelloReq = z.infer<typeof AppHelloReqSchema>;

export const AppHelloResSchema = z.object({
  ok: z.boolean(),
  /** Целевая задача участника ПО МНЕНИЮ СЕРВЕРА — она главнее локальной
   *  метки: владелец меняет её в таблице участников. '' = не задана. */
  target_task: z.string().max(16).default(''),
});
export type AppHelloRes = z.infer<typeof AppHelloResSchema>;
